import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { APP_CONFIG } from 'src/app/lib/angular/injection-tokens';
import { IAppConfig } from 'src/app/lib/config/app-config';
import { BaseComponent } from '../base/base-component.component';
import { Subject } from 'rxjs';
import { AuthenticationResult, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { AppConstants } from 'src/app/constants/constants';
import { AuthError } from 'msal';

@Component({
  selector: 'app-msalsignedin',
  templateUrl: './msalsignedin.component.html',
})
export class MsalsignedinComponent extends BaseComponent implements OnInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  siteLanguageCode: string = this.localeId;

  constructor(
    private router: Router,
    @Inject(APP_CONFIG) private config: IAppConfig,
    @Inject(LOCALE_ID) protected localeId: string,
    private authService: MsalService
  ) { 
    super();
  }

  ngOnInit(): void {
    let redirect$ = this.authService.handleRedirectObservable().subscribe(
      (authResult: AuthenticationResult) => {
        /**Check if this redirection was previously from forgot password */
        if(authResult &&
          authResult.account !== null &&
          authResult.account.idTokenClaims !== null &&
          authResult.account.idTokenClaims[AppConstants.ID_TOKEN_CLAIMS_ACR] ===
          AppConstants.B2C_SI_FORGOT_PW
        ) {
          sessionStorage.clear();
          localStorage.clear();
          this.authService.logout();
          return;
        }

        if(this.authService.instance.getAllAccounts().length > 0)
          this.router.navigate([AppConstants.DASHBOARD_PAGE]);
        else
          this.router.navigate([AppConstants.WELCOME_PAGE]);
      },
      (error: AuthError) => {
        if(error.errorMessage.indexOf(AppConstants.FORGOT_YOUR_PASSWORD_ERROR_CODE) !== -1) {
          this.redirectToB2cForgotYourPassword();
        }
      }
    );

    this.addSubscription(redirect$);
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    super.ngOnDestroy();
  }

  redirectToB2cForgotYourPassword() : void {
    try {
      let forgotYourPasswordRequest: RedirectRequest | PopupRequest = {
        authority: this.config.b2cPolicies.authorities.forgotPassword,
        scopes: [this.config.protectedResourceDefaultScope],
      }

      if (this.siteLanguageCode == AppConstants.WELSH_LANG_CODE) {
        forgotYourPasswordRequest.extraQueryParameters = {
          ui_locales: AppConstants.WELSH_GB_LANG_CODE,
        };
      } else if (this.siteLanguageCode == AppConstants.DEFAULT_LANG_CODE) {
        forgotYourPasswordRequest.extraQueryParameters = {
          ui_locales: AppConstants.DEFAULT_LANG_CODE,
        };
      }

      this.authService.loginRedirect(forgotYourPasswordRequest);
    }
    catch(err) {
      console.error(err);
      this.router.navigate([AppConstants.WELCOME_PAGE]);
    }
  }
}
